import { useAuth } from './useAuth';
import { BOUNDARY_ROLES, ROLE_EXTERNAL } from '../constants/roles';
import type { User } from '../types';

/**
 * THE predicate for the new External-portal IA (plan P15): the account holds ONLY boundary roles,
 * one of them External, and `/auth/me` carried `billingEnabled`. `billingEnabled` mirrors a global
 * kill switch (partners and staff see it too), hence the role test. Layout, the routes, useBilling and
 * the Home all key off this one rule so they can never disagree.
 */
export function isBillingIaUser(user: Pick<User, 'roles' | 'billingEnabled'> | null | undefined): boolean {
  const roles = user?.roles ?? [];
  if (roles.length === 0) return false;
  if (!roles.every((r) => BOUNDARY_ROLES.includes(r))) return false;
  if (!roles.includes(ROLE_EXTERNAL)) return false;
  return user?.billingEnabled === true;
}

/** Hook form of {@link isBillingIaUser} over the signed-in user. Pure read — no fetch. */
export function useBillingIa(): boolean {
  const { user } = useAuth();
  return isBillingIaUser(user);
}
